import React from 'react';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Content from './components/Content';
import { css } from 'emotion';
import Footer from './components/Footer';
import { HashRouter as Router } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div className={style.container}>
        <Navigation />
        <Header />
        <Content />
        <Footer />
      </div>
    </Router>
  );
}

const style = {
  container: css`
    min-width: 320px;
  `,
};

export default App;
